// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as PlaceOrderRepo from "./PlaceOrderRepo.bs.js";
import * as DummyPlaceOrderRepo from "./DummyPlaceOrderRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.getEnv(undefined);
  if (match >= 2) {
    return DummyPlaceOrderRepo.PlaceOrderRepo;
  } else {
    return PlaceOrderRepo.PlaceOrderRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
